import React, { useState } from 'react';
import './ProteinTooltip.css';

const ProteinTooltip = ({ proteinName, proteinSummary, children }) => {
  const [isVisible, setIsVisible] = useState(false);
  const [position, setPosition] = useState({ x: 0, y: 0 });
  const [hideTimeout, setHideTimeout] = useState(null);
  const [isHoveringTrigger, setIsHoveringTrigger] = useState(false);
  const [isHoveringTooltip, setIsHoveringTooltip] = useState(false);

  const handleMouseEnter = (event) => {
    if (proteinSummary) {
      setIsHoveringTrigger(true);
      
      // Clear any pending hide timeout
      if (hideTimeout) {
        clearTimeout(hideTimeout);
        setHideTimeout(null);
      }
      
      const rect = event.currentTarget.getBoundingClientRect();
      const newPosition = {
        x: rect.left + rect.width / 2,
        y: rect.top
      };
      setPosition(newPosition);
      setIsVisible(true);
    }
  };

  const handleMouseLeave = () => {
    setIsHoveringTrigger(false);
    
    // Add a delay before hiding to allow mouse to move to tooltip
    const timeout = setTimeout(() => {
      // Only hide if we're not hovering over either trigger or tooltip
      if (!isHoveringTrigger && !isHoveringTooltip) {
        setIsVisible(false);
      }
    }, 200);
    setHideTimeout(timeout);
  };

  const handleTooltipMouseEnter = () => {
    setIsHoveringTooltip(true);
    
    // Clear hide timeout when hovering over tooltip content
    if (hideTimeout) {
      clearTimeout(hideTimeout);
      setHideTimeout(null);
    }
  };

  const handleTooltipMouseLeave = () => {
    setIsHoveringTooltip(false);
    
    // Hide immediately when leaving tooltip content if not hovering trigger
    if (!isHoveringTrigger) {
      setIsVisible(false);
    }
  };

  return (
    <span className="protein-tooltip-container">
      <span 
        className="protein-tooltip-trigger"
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      >
        {children}
        {proteinSummary && (
          <span className="protein-info-icon">
            ⓘ
          </span>
        )}
      </span>
      
      {isVisible && proteinSummary && (
        <>
          <div className="protein-tooltip-backdrop" onClick={() => setIsVisible(false)} />
          
          <div 
            className="protein-tooltip-wrapper"
            style={{
              left: position.x,
              top: position.y - 10,
              transform: 'translateX(-50%) translateY(-100%)'
            }}
            onMouseEnter={handleTooltipMouseEnter}
            onMouseLeave={handleTooltipMouseLeave}
          >
            {/* CONTENT handles the box design and scrolling text */}
            <div className="protein-tooltip-content">
              <span className="tooltip-icon">ⓘ</span> {proteinSummary}
            </div>
            
            <div className="protein-tooltip-arrow" />
          </div>
        </>
      )}
    </span>
  );
};

export default ProteinTooltip;